import {
  AccountDetails_viewer_accounts as Account,
  AccountDetails_viewer as Viewer,
} from "../../kraken/graphql-types/AccountDetails";
import { isPresent, mapSupplyType } from "../../../utils/helpers";
import { ContactPreference } from "../../../screens/UpdateContactPrefsScreen/ContactOption";
import { ProfileFieldMapTypes } from "../../profileFieldMapContextHelpers";

export const mapToAddressProps = (accounts: (Account | null)[] | null) => {
  if (!accounts) {
    return [];
  }
  return accounts.filter(isPresent).map((account: Account) => {
    return {
      id: account.number!,
      address: account.billingAddress!,
    };
  });
};

export const mapToBusinessDetailsProp = (
  accounts: (Account | null)[] | null
) => {
  const allAccountsWithBusinesses = accounts?.filter((a) => a?.business) ?? [];
  const allBusinesses = allAccountsWithBusinesses.map((a) => a?.business);
  const uniqueBusinessAbns = Array.from(
    new Set(allBusinesses.map((business) => business?.number))
  );
  const uniqueBusinesses = uniqueBusinessAbns
    .map((number) => {
      return allBusinesses.find((business) => business?.number === number);
    })
    .filter(isPresent);

  const businessAccountProps = uniqueBusinesses.map((business) => ({
    abn: business.number,
    name: business.name,
  }));

  return {
    addresses: mapToAddressProps(accounts),
    businessAccounts: businessAccountProps,
  };
};

const mapToContactPreferenceProp = (account: Account, email?: string) => {
  return {
    id: account.number,
    address: account.properties?.[0]?.address?.toUpperCase(),
    recipient: {
      address: account.billingAddress?.toUpperCase(),
      email,
      shouldPromptChatOnEmpty: false,
    },
    supplyTypes:
      account.agreements
        ?.map((agreement) => {
          return mapSupplyType(agreement?.supplyType ?? null);
        })
        .filter(isPresent) ?? [],
    preference: account.commsDeliveryPreference
      ? ContactPreference[account.commsDeliveryPreference]
      : null,
    type: ProfileFieldMapTypes.KRAKEN,
  };
};

export const mapToContactPreferenceProps = (krakenViewer: Viewer | null) => {
  if (
    !krakenViewer ||
    !krakenViewer.accounts ||
    krakenViewer.accounts?.length === 0
  ) {
    return [];
  }

  return krakenViewer.accounts
    .reduce((accounts: Account[], account: Account | null) => {
      const propertiesLength = account?.properties?.length || 0;
      const agreementsLength = account?.agreements?.length || 0;
      if (propertiesLength > 0 && agreementsLength > 0) {
        if (account?.business) {
          if (
            accounts.findIndex(
              (a) => a.business?.number === account?.business?.number
            ) === -1
          ) {
            accounts.push(account);
          }
        } else if (account) {
          accounts.push(account);
        }
      }
      return accounts;
    }, [])
    .filter(isPresent)
    .map((account) => mapToContactPreferenceProp(account, krakenViewer.email)); // email is on the 'viewer' level, i.e., applies to every account
};
